export * as footer from './footer' // footer.standard, footer.community, etc
export { default as mainNav } from './main-nav'
export type { ChildMenu, LinkDefExtended } from './main-nav'
export type { SiteDef } from '../types'